import { render, staticRenderFns } from "./JotformWidget.vue?vue&type=template&id=17012e2b"
import script from "./JotformWidget.vue?vue&type=script&lang=js"
export * from "./JotformWidget.vue?vue&type=script&lang=js"
import style0 from "./JotformWidget.vue?vue&type=style&index=0&id=17012e2b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports